export default class SSHDUser {
  constructor(sshd = '', password = '') {
    this.sshd = sshd;
    this.password = password;
  }
}
